/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Recovery_SavedInputs */

const en_two_fa_recovery_saved = /** @type {(inputs: Two_Fa_Recovery_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have saved my recovery codes in a safe place.`)
};

const nl_two_fa_recovery_saved = /** @type {(inputs: Two_Fa_Recovery_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik heb mijn herstelcodes op een veilige plek bewaard.`)
};

/**
* | output |
* | --- |
* | "I have saved my recovery codes in a safe place." |
*
* @param {Two_Fa_Recovery_SavedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_recovery_saved = /** @type {((inputs?: Two_Fa_Recovery_SavedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Recovery_SavedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_recovery_saved(inputs)
	return en_two_fa_recovery_saved(inputs)
});